/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './wan-list.scss';

/* eslint-disable import/no-unresolved, import/default */

import wanListTemplate from './wan-list.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.wanList', [])
    .directive('tkWanList', WanList)
    .name;

/*@ngInject*/
function WanList() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: WanListController,
        controllerAs: 'vm',
        templateUrl: wanListTemplate
    };
}

/*@ngInject*/
function WanListController($rootScope, $scope, $element, toast, gatewayCommandService, $filter, $mdMedia, $translate, types) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;

        vm.allConnectivityTypes = [];
        vm.connectivityTypes = [];

        vm.query = {
            order: 'index'
        };

        vm.preferredPingIpAddress = null;
        vm.preferredConnectivity = null;
        vm.fallbackConnectivity = null;

        vm.getWanInfo = getWanInfo;
        vm.setPreferredPingIpAddress = setPreferredPingIpAddress;
        vm.setPreferredAndFallback = setPreferredAndFallback;
        vm.getAllowedPreferredOrFallback = getAllowedPreferredOrFallback;

        vm.onReorder = function () {
            updateConnectivityTypes();
        };

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    function reload() {
        vm.allConnectivityTypes.length = 0;
        vm.connectivityTypes.length = 0;
        vm.preferredPingIpAddress = null;
        vm.preferredConnectivity = null;
        vm.fallbackConnectivity = null;
    }

    function getWanInfo() {
        reload();
        vm.connectivityTypesPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wanCommand.getConnectivityTypes.value, {});
        vm.connectivityTypesPromise.then(
            (connectivityTypes) => {
                vm.allConnectivityTypes = connectivityTypes;
                updateConnectivityTypes();
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );

        vm.preferredPingIpAddressPromise = gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wanCommand.getPreferredPingIpAddress.value, {});

        vm.preferredPingIpAddressPromise.then(
            (response) => {
                vm.preferredPingIpAddress = response.ipAddr;
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function updateConnectivityTypes() {
        vm.connectivityTypes = $filter('orderBy')(vm.allConnectivityTypes, vm.query.order);
    }

    function setPreferredPingIpAddress() {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wanCommand.setPreferredPingIpAddress.value, {ipAddr: vm.preferredPingIpAddress}).then(
            () => {
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function setPreferredAndFallback () {
        var params = {
            preferredIdx: vm.preferredConnectivity.index,
            fallbackIdx: vm.fallbackConnectivity.index
        };

        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wanCommand.setPreferredFallbackConnectivityType.value, params).then(
            () => {
                getWanInfo();
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function getAllowedPreferredOrFallback(alreadySelectedType) {
        var allowed = {};
        if (vm.connectivityTypes) {
            allowed = vm.connectivityTypes.slice();
            var index = allowed.indexOf(alreadySelectedType);
            if (index > -1) {
                allowed.splice(index, 1);
            }
        }
        return allowed;
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway/wan/wan-list.directive.js